import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Chip } from '@mui/material';
import { 
  WalteroButton, 
  WalteroTabs, 
  WalteroTabPanel 
} from '../waltero';
import { hasOrganizationAccess } from '../../utils/auth';
import { ADMIN_ORGANIZATION_ID } from '../../config/api';
import { usePerformanceData } from '../../context/PerformanceDataContext';
import {
  SignalCellularAlt as ConnectivityIcon,
  BatteryStd as BatteryIcon,
  Analytics as AnalyticsIcon,
  BugReport as DiagnosticIcon,
  ReportProblem as IssuesIcon,
  Description as LogsIcon
} from '@mui/icons-material';

const PerformanceTabNavigation = () => {
  const { activeTab, handleTabChange } = usePerformanceData();
  const isAdmin = hasOrganizationAccess(ADMIN_ORGANIZATION_ID);

  // Tab configuration for WalteroTabs component
  const performanceTabs = [
    { 
      id: 'connectivity', 
      label: 'Fleet Connectivity',
      icon: ConnectivityIcon
    },
    { 
      id: 'battery', 
      label: 'Battery Analytics',
      icon: BatteryIcon
    }
  ];
  
  // Add admin-only tabs if user has access
  if (isAdmin) {
    performanceTabs.push(
      {
        id: 'success',
        label: 'Success Rate Analysis',
        icon: AnalyticsIcon,
        adminOnly: true
      },
      {
        id: 'diagnostic',
        label: 'Diagnostic Analysis',
        icon: DiagnosticIcon,
        adminOnly: true
      },
      {
        id: 'logs',
        label: 'Logs',
        icon: LogsIcon,
        adminOnly: true
      }
    );
  }

  return (
    <WalteroTabs
      tabs={performanceTabs}
      value={activeTab}
      onChange={handleTabChange}
      ariaLabel="Performance data views"
      showAdminBadges={true}
    />
  );
};

PerformanceTabNavigation.propTypes = {};

export default PerformanceTabNavigation;